import * as React from "react";
import { Button } from "antd";
import { MinusCircleOutlined } from "@ant-design/icons";
import { cloneDeep, get } from "lodash";
import { store } from "../../../../store";
import { formSet, formSetValue, formTriggerValidation } from "../../../gvc/testNewForm/utils";
import { FormListFieldItem } from "../../../gvc/formListFieldItem";
import { CpInput } from "../../../gvc/testNewForm/CpInput";
import { AddonRegistryMirrorItemInput } from "../../../../schema/types/mk8s/input/addons/registryMirror";
import { useCpFormContext } from "../../../../components/form/useCpFormContext";

interface Props {
  name?: string;
  item?: AddonRegistryMirrorItemInput;
  index?: number;
}
export const CpArrayItemRegistryMirror: React.FC<Props> = React.memo(({ name: _name, item: _item, index: _index }) => {
  const { id } = useCpFormContext();
  const name = _name!;
  const item = _item!;
  const index = _index!;

  function remove() {
    const form = store.getState().form.instances[id];
    const values = form.values;
    const items = get(values, name) || [];
    let _items = cloneDeep(items);
    _items = _items.filter((i) => i.id !== item.id);
    formSetValue(id, name, _items);

    formTriggerValidation(id);
  }

  return (
    <FormListFieldItem columnCount={2} hasRemoveButton className="mb-1">
      <CpInput name={`${name}.${index}.registry`} />
      <CpInput name={`${name}.${index}.mirror`} />
      <Button type={`text`} danger icon={<MinusCircleOutlined />} onClick={() => remove()} />
    </FormListFieldItem>
  );
});
